import { useEffect, useState } from 'react'

type FeatureFlags = {
  registration_enabled: boolean
  version?: string
}

export function useFeatureFlags() {
  const [flags, setFlags] = useState<FeatureFlags>({ registration_enabled: true })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchFlags = async () => {
    try {
      setLoading(true)
      setError(null)
      const API_BASE = import.meta.env.VITE_API_BASE_URL || ''
      const res = await fetch(`${API_BASE}/api/config`, { credentials: 'include' })
      if (!res.ok) throw new Error(res.statusText)
      const data = await res.json()
      setFlags(data.flags ?? { registration_enabled: true })
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : 'Unknown error'
      setError(errorMessage)
      // Keep defaults on error to avoid breaking user experience
      setFlags({ registration_enabled: true })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchFlags()
  }, [])

  return { flags, loading, error, refetch: fetchFlags }
}